import { __awaiter, __generator } from "tslib";
import { IDBEngineTable } from './table';
var IDBEngineTransaction = /** @class */ (function () {
    function IDBEngineTransaction(proxyTransaction, engineAspects) {
        this.proxyTransaction = proxyTransaction;
        this.engineAspects = engineAspects;
        this.tables = proxyTransaction.objectStoreNames;
        this.mode = proxyTransaction.mode;
        if (engineAspects === null || engineAspects === void 0 ? void 0 : engineAspects.transaction) {
            this.applyAspectPatch();
        }
    }
    IDBEngineTransaction.prototype.table = function (tableName) {
        var objectStore = this.proxyTransaction.objectStore(tableName);
        return new IDBEngineTable(this.mode, objectStore, this.engineAspects, this);
    };
    IDBEngineTransaction.prototype.commit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.proxyTransaction.done];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/, true];
                }
            });
        });
    };
    IDBEngineTransaction.prototype.rollback = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_2, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 1, , 6]);
                        this.proxyTransaction.abort();
                        return [3 /*break*/, 6];
                    case 1:
                        err_2 = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        // Should await to prevent unhandled rejection
                        return [4 /*yield*/, this.proxyTransaction.done];
                    case 3:
                        // Should await to prevent unhandled rejection
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        // Transaction did rollback caused by errors
                        return [2 /*return*/, true];
                    case 5: return [2 /*return*/, false];
                    case 6: return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * bind the hook stub to the transaction object
     */
    IDBEngineTransaction.prototype.applyAspectPatch = function () {
        var _a;
        var transactionAspects = (_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.transaction;
        var hookTarget = this;
        transactionAspects === null || transactionAspects === void 0 ? void 0 : transactionAspects.commit.patch(hookTarget, 'commit');
        transactionAspects === null || transactionAspects === void 0 ? void 0 : transactionAspects.rollback.patch(hookTarget, 'rollback');
        transactionAspects === null || transactionAspects === void 0 ? void 0 : transactionAspects.table.patch(hookTarget, 'table');
    };
    return IDBEngineTransaction;
}());
export { IDBEngineTransaction };
//# sourceMappingURL=transaction.js.map